const numberConfig = {
  1: '一',
  2: '二',
  3: '三',
  4: '四',
  5: '五',
  6: '六',
  7: '七',
  8: '八',
  9: '九'
}
const courseArr = [{
  id: 0,
  name: '信息素养和数字素养赋能数字生活、学习和工作',
  school: '中山大学',
  author: '潘燕桃',
  time: '2022年9月16日（周五）19:30-20:30',
  cover: require('@/assets/pyt_1.png'),
  mobileCover: require('@/assets/pyt_1_mobile.jpg'),
  path: 'https://meeting.tencent.com/live/15623295646168835836',
  jobTitle: '博士生导师',
  introduction: '中山大学信息管理学院教授、博士生导师。主要研究方向包括信息素养和数字素养及其教育、公共文化及其服务、信息资源管理等。迄今已出版学术著作与专业教材12部，发表学术论文50余篇，主持和参加国家级、省市级科研项目20余项，获得各级教学和科研奖励20余项。',
  courseContent: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为贯彻落实“数字中国”战略，更好地把握“教育数字化转型”所面临的机遇与挑战，在对信息素养和数字素养概念进行辨析的基础上，探讨信息素养和数字素养如何赋能数字生活、学习和工作，以提升高职高专院校师生的信息素养和数字素养，力求助力全省师生参加高职高专院校信息素养大赛。',
  fileId: '387702306256817555'
}, {
  id: 1,
  name: '检索入门：工具与技巧',
  school: '东莞职业技术学院',
  author: '吴惠茹',
  time: '2022年9月21日（周三）19:30-20:30',
  cover: require('@/assets/whr_2.png'),
  mobileCover: require('@/assets/whr_2_mobile.jpg'),
  path: 'https://meeting.tencent.com/live/15409608739480336289',
  jobTitle: '参考咨询部负责人',
  introduction: '吴惠茹，硕士，东莞职业技术学院副研究馆员，长期从事图书馆参考咨询服务以及信息素养教育的研究与教学，发表核心论文10余篇，主持、主要参与教育部、省、市级课题多项。',
  courseContent: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;信息时代，我们几乎每天都要借助检索信息来解决各方面的问题。不同类型的信息，需要利用相应的检索工具和平台才能快速检索出来。那么，常用的检索工具都有哪些？如何有效利用这些检索工具获取想要的信息？有哪些检索技巧可以帮助我们实现高效检索？讲座将结合检索实例和大赛真题为你详细讲解，助你成为检索达人！',
  fileId: '387702306151268903'
}, {
  id: 2,
  name: '网络好用的资源、平台及参赛经验分享',
  school: '顺德职业技术学院',
  author: '周辉',
  time: '2022年9月23日（周五）19:30-20:30',
  cover: require('@/assets/zh_3.png'),
  mobileCover: require('@/assets/zh_3_mobile.jpg'),
  path: 'https://meeting.tencent.com/live/5789835273066119137',
  jobTitle: '',
  introduction: '周辉，毕业于武汉大学，硕士，馆员，顺德职业技术学院。从事信息素养教育教学、信息服务等工作10余年。2020年获全国高职院校信息素养大赛优秀指导教师奖，2021年获全国高职院校信息素养大赛先进工作者称号。',
  courseContent: `
  <div>客观存在的信息——好用的OA资源介绍</div>
  <div>信息意识——资源获取的开端</div>
  <div>信息能力——检索工具、技巧</div>
  <div>参赛指导学生经验分享</div>
  `,
  fileId: '387702306457143574'
}, {
  id: 3,
  name: '如何运用大赛平台取得更加优异的成绩',
  school: '方正阿帕比',
  author: '程微元',
  time: '2022年9月28日（周三）19:30-20:30',
  cover: require('@/assets/cwy_4.png'),
  mobileCover: require('@/assets/cwy_4_mobile.jpg'),
  path: 'https://meeting.tencent.com/live/3163367221364642095',
  jobTitle: '',
  introduction: '',
  courseContent: `
  <div>如何运用互联网思路和模型备赛备考？</div>
  <div>读懂数据：AARRR转化漏斗模型；优化关键数据</div>
  <div>巧用平台：拉新——促活——留存；</div>
  <div>赛教融合：平台学习资源学习方法</div>
  `,
  fileId: '387702306436249999'
}, {
  id: 4,
  name: '商务信息的搜索与利用',
  school: '广州城市职业学院',
  author: '周莉娜',
  time: '2022年9月30日（周五）19:30-20:30',
  cover: require('@/assets/zln_5.png'),
  mobileCover: require('@/assets/zln_5_mobile.jpg'),
  path: 'https://meeting.tencent.com/live/1440310399054116691',
  jobTitle: '图书馆素质教育中心主任',
  introduction: '周莉娜老师，硕士，毕业于中山大学，广州市图书馆学会阅读推广委员会委员。从事信息素养教育教学、阅读推广等工作十余年，2019年全国高职院校信息素养大赛优秀讲师，2020年、2021年全国高职院校信息素养大赛优秀指导老师，指导学生两次获得全国二等奖（全国前50名）。主讲《大学生活与信息素养》、《商务信息搜索与处理》等课程，主持策划的多个阅读推广项目在全国、省、市图书馆学会比赛中获奖。',
  courseContent: `
  <div>1、商业信息概述</div>
  <div>——商业信息的概念、类型、特点</div>
  <div>2、商标信息的检索</div>
  <div>——企业无形资产的守护者</div>
  <div>3、经济类数据库的检索</div>
  <div>——权威数据的获取渠道</div>
  <div>4、大数据时代指数工具的利用</div>
  <div>——营销决策的好助手</div>
  <div>5、商务信息搜索真题分析</div>
  <div>——基于全国信息素养大赛真题</div>
  `,
  fileId: '387702306617662960'
}, {
  id: 5,
  name: '发现文献点滴，助力知识获取——学术期刊检索方法',
  school: '广州番禺职业技术学院',
  author: '吴紫山',
  time: '2022年10月5日（周三）19:30-20:30',
  cover: require('@/assets/wzs_6.png'),
  mobileCover: require('@/assets/wzs_6_mobile.jpg'),
  path: 'https://meeting.tencent.com/live/5573010480478996422',
  jobTitle: '信息咨询员',
  introduction: '吴紫山，学士，毕业于华南理工大学电子商务专业，广州番禺职业技术学院馆员，会计师，从事多年的读者培训、信息咨询、数字资源管理、信息素养教育研究等工作，发表核心论文多篇。',
  courseContent: `
  <div>本讲座从论文期刊的外部特征入手，教学如何提炼检索关键词，提升检索效率，拓宽检索思路，帮助大家提高信息素养大赛客观题的准确率和速度。</div>
  <div>1．期刊论文的外部特征</div>
  <div>2．提升检索效率的方法和技术</div>
  <div>3．搞定检索的五步骤</div>
  <div>4．五种拓宽思路的检索方法</div>
  <div>5．值得掌握的三大高级检索技术</div>
  <div>6．信息检索技术的提分技巧</div>
  `,
  fileId: '387702306799537769'
}, {
  id: 6,
  name: '专利信息与标准信息的检索与分析',
  school: '广东轻工职业技术学院',
  author: '赵苹',
  time: '2022年10月7日（周五）19:30-20:30',
  cover: require('@/assets/zp_7.png'),
  mobileCover: require('@/assets/zp_7_mobile.jpg'),
  path: 'https://meeting.tencent.com/live/1816953458826174799',
  jobTitle: '',
  introduction: '赵苹，女，硕士，广东轻工职业技术学院图书馆副研究馆员，长期从事信息素养教育的研究与相关教学工作，在专业期刊上发表论文20余篇，副主编信息检索类教材2部，所撰写的信息素养案例多次在中国图书馆学会、全国高职院校图书馆馆长论坛、全国高校信息素养研讨会上获奖。',
  courseContent: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;结合本次信息素养大赛备赛备考的实际需要，本课程主要围绕专利信息检索与标准信息检索的意义与基础知识，重点进行相关检索思路与策略的讲述、专利信息与标准信息数据库与检索平台的使用方法介绍以及相关案例的分析与评价等。通过本课程相关知识点与历年信息素养大赛真题的讲解，提升广大学子专利信息与标准信息检索与应用的能力。',
  fileId: '387702306882570724'
}, {
  id: 7,
  name: '变与不变，破解职场中的信息素养“应用题”',
  school: '深圳职业技术学院',
  author: '杨光武',
  time: '2022年10月12日（周三）19:30-20:30',
  cover: require('@/assets/ygw_8.png'),
  mobileCover: require('@/assets/ygw_8_mobile.jpg'),
  path: 'https://meeting.tencent.com/live/16902268432330232547',
  jobTitle: '图书馆信息服务部主任',
  introduction: '杨光武 男，深圳职业技术学院图书馆信息服务部主任，副研究馆员。广东省图书馆学会理事、广东省职业院校图工委秘书长。长期从事学科服务和教学工作，主讲广东省高职院校信息素养共享课程、本校信息素养通识课程。合作出版专著1部，教材2部。发表论文10余篇，主持和参与完成省级课题4项。两次获全国高校图书馆服务创新案例大赛二等奖、2017年全国高校信息素养教育研讨会案例一等奖。',
  courseContent: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;信息素养不只是用知网查论文。在专业学习和工作（未来的你）中，你会遇到各种各样的问题：市场调研、创业计划、创意方案……如何运用信息素养，解好这些应用题？怎样根据不同问题，有效调配信息素养知识和技能？来线上课堂，和老师一起探索吧。',
  fileId: '387702307098007276'
}, {
  id: 8,
  name: '如何做研究综述，怎样答主观题',
  school: '北京大学',
  author: '崔海媛',
  time: '2022年10月14日（周五）19:30-20:30',
  cover: require('@/assets/chy_9.png'),
  mobileCover: require('@/assets/chy_9_mobile.jpg'),
  path: 'https://meeting.tencent.com/live/12192672123004382100',
  jobTitle: '图书馆信息服务部主任',
  introduction: '北京大学图书馆研究馆员，研发服务中心副主任。长期从事图书馆信息化技术研究、开发、服务和管理。负责与执行完成十多项国家级科研项目，在专业核心期刊发表学术论文二十几篇，出版专著两部：《机构知识库构建指南》、《研究数据管理和服务》。研究领域包括：开放科学、开放获取、知识库构建、数据管理与服务、数字素养、图书馆系统研究与开发、图书联盟发展等。',
  courseContent: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;学会做研究性综述，提高逻辑思维能力，是具备信息素养能力的重要标志，将有效帮助我们寻找工作、学习和生活中遇到的多种问题解决途径。本讲座将以完成主观题为中心，从选题、文献检索、阅读筛选和撰写报告等几方面介绍如何做研究性综述，帮助大家了解和掌握答好主观题的方法。',
  fileId: '387702307145557503'
}]
export {
  numberConfig,
  courseArr
}
